import { useId } from 'react';
import { COLOR_TEXT_PRIMARY_INVERSE } from '@alltrails/denali/tokens';

type TwitterProps = {
  className?: string;
  openInNewTab?: boolean;
  color?: string;
  noFollowSocials?: boolean;
};

export default function TwitterIcon({ className = '', openInNewTab = false, color = COLOR_TEXT_PRIMARY_INVERSE, noFollowSocials }: TwitterProps) {
  const titleId = useId();
  return (
    <a
      href="https://www.x.com/alltrails"
      target={openInNewTab ? '_blank' : '_self'}
      rel={`noreferrer${noFollowSocials ? ' nofollow' : ''}`}
      className={className}
    >
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 25 24">
        <title id={titleId}>X</title>
        <g fill="none" fillRule="evenodd">
          <g fill={color} fillRule="nonzero">
            <g>
              <g>
                <path d="M12.5,2c5.5,0,10,4.5,10,10s-4.5,10-10,10S2.5,17.5,2.5,12,7,2,12.5,2ZM12.5,0C5.9,0,.5,5.4.5,12s5.4,12,12,12,12-5.4,12-12S19.1,0,12.5,0Z" />
                <path d="M13.7,11.1l3.5-5.1h-.8l-3,4.4-2.4-4.4h-2.8l3.7,6.7-3.7,5.3h.8l3.2-4.7,2.6,4.7h2.8l-3.8-6.9h0ZM12.6,12.7l-.4-.7-3-5.3h1.3l2.4,4.3.4.7,3.1,5.5h-1.3l-2.5-4.5h0Z" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </a>
  );
}
